import { render, staticRenderFns } from "./SmallTenderCard.vue?vue&type=template&id=44a20f06&"
import script from "./SmallTenderCard.vue?vue&type=script&lang=js&"
export * from "./SmallTenderCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports